import { render, staticRenderFns } from "./AddPlace.vue?vue&type=template&id=10806a0a&"
import script from "./AddPlace.vue?vue&type=script&lang=js&"
export * from "./AddPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports